import { render, staticRenderFns } from "./TableActivityLog.vue?vue&type=template&id=a968306a&scoped=true"
import script from "./TableActivityLog.vue?vue&type=script&lang=js"
export * from "./TableActivityLog.vue?vue&type=script&lang=js"
import style0 from "./TableActivityLog.vue?vue&type=style&index=0&id=a968306a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a968306a",
  null
  
)

export default component.exports